import Form from 'src/utils/Form.js'

class Transaction extends Form {
  constructor(data, config = null, responseType = 'json') {
    super(data, config || Form.config, responseType)
  }

  fetch(then) {
    const side = this.side === 'credit' ? 'incoming' : 'outgoing'
    return super.get(`transactions/${side ? side + '/' : ''}${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  make(then) {
    const side = this.side === 'credit' ? 'incoming' : 'outgoing'
    return super.post(`transactions/${side ? side + '/' : ''}make`, {
        transfer_reference: this.transfer_reference,
        side: this.side
    }).then((data) => {
        this.originalData = data
        for (let field in this.originalData) {
            this[field] = data[field]
        }
        then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`transactions?${parameters}`).then(then)
  }

  static incoming(parameters, then) {
    return new Form().get(`transactions/incoming?${parameters}`).then(then)
  }

  static outgoing(parameters, then) {
    return new Form().get(`transactions/outgoing?${parameters}`).then(then)
  }

  create(then) {
    this.rebit_account_id = typeof this.rebit_account_id === 'object' && this.rebit_account_id !== null ? this.rebit_account_id.id : this.rebit_account_id
    const side = this.side === 'credit' ? 'incoming' : 'outgoing'
    return super.post(`transactions/${side ? side : ''}`).then(then)
  }

  update(then) {
    this.rebit_account_id = typeof this.rebit_account_id === 'object' && this.rebit_account_id !== null ? this.rebit_account_id.id : this.rebit_account_id
    const side = this.side === 'credit' ? 'incoming' : 'outgoing'
    return super.patch(`transactions/${side ? side + '/' : ''}${this.id}`).then(then)
  }

  updateInline(then) {
    const side = this.side === 'credit' ? 'incoming' : 'outgoing'
    return super.put(`transactions/${side ? side + '/' : ''}${this.id}`).then(then)
  }

  destroy(then) {
    const side = this.side === 'credit' ? 'incoming' : 'outgoing'
    return super.delete(`transactions/${side ? side + '/' : ''}${this.id}`).then(then)
  }

  requestReceipt(then) {
    const side = this.side === 'credit' ? 'incoming' : 'outgoing'
    return super.post(`transactions/${side ? side + '/' : ''}${this.id}/request-receipt`).then(then)
  }

  download(then) {
    return super.get(`transactions/${this.id}/download-receipts`).then(then)
  }
}

export default Transaction
